export default {
      id: "save-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#save",
      toString: function () {
        return this.url;
      }
    }